import { render } from "./InspectDetail.vue?vue&type=template&id=1db6b3f2&scoped=true"
import script from "./InspectDetail.vue?vue&type=script&lang=js"
export * from "./InspectDetail.vue?vue&type=script&lang=js"

import "./InspectDetail.vue?vue&type=style&index=0&id=1db6b3f2&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db6b3f2"]])

export default __exports__